import type { BioPod } from "@/features/pods/types";

/**
 * Stand-in pod data, from gaia-app.
 *
 * Reached only through `mockPodsRepository`, so the screens cannot accidentally depend on it and
 * deleting this file is the whole of the cleanup once the fleet serves real pods.
 */
export const MOCK_PODS: BioPod[] = [
  {
    id: "ORION01",
    name: "ORION 01",
    site: "Paris HQ",
    tenant: "client-a",
    status: "nominal",
    lastUpdate: new Date().toISOString(),
    sensors: [
      // gaia-app had 100.4 °C here, flagged "nominal". A plausible figure, so a screenshot of this
      // screen does not raise a question that has nothing to do with the screen.
      { label: "Temperature", value: 22.4, unit: "°C", status: "nominal" },
      { label: "Humidity", value: 68, unit: "%", status: "nominal" },
      { label: "CO₂", value: 820, unit: "ppm", status: "nominal" },
      { label: "EC", value: 4.2, unit: "mS/cm", status: "nominal" },
      { label: "pH", value: 6.1, unit: "", status: "nominal" },
      { label: "PPFD", value: 380, unit: "μmol", status: "nominal" },
    ],
  },
  {
    id: "ORION02",
    name: "ORION 02",
    site: "Paris HQ",
    tenant: "client-a",
    status: "warning",
    lastUpdate: new Date().toISOString(),
    sensors: [
      { label: "Temperature", value: 26.1, unit: "°C", status: "nominal" },
      { label: "Humidity", value: 71, unit: "%", status: "nominal" },
      { label: "CO₂", value: 910, unit: "ppm", status: "warning" },
      { label: "EC", value: 3.9, unit: "mS/cm", status: "nominal" },
      { label: "pH", value: 6.4, unit: "", status: "nominal" },
      { label: "PPFD", value: 410, unit: "μmol", status: "nominal" },
    ],
  },
  {
    id: "ORION03",
    name: "ORION 03",
    site: "Lyon Lab",
    tenant: "client-b",
    status: "fault",
    lastUpdate: new Date().toISOString(),
    sensors: [
      { label: "Temperature", value: 18.2, unit: "°C", status: "nominal" },
      { label: "Humidity", value: 55, unit: "%", status: "nominal" },
      { label: "CO₂", value: 1100, unit: "ppm", status: "warning" },
      { label: "EC", value: 4.1, unit: "mS/cm", status: "nominal" },
      { label: "pH", value: 5.8, unit: "", status: "nominal" },
      // Zero light with the pod in fault: the reading that explains the status.
      { label: "PPFD", value: 0, unit: "μmol", status: "fault" },
    ],
  },
];
